import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "error",
  "use": "error-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"error\">\r\n    <path d=\"M28.78 24.75c-.79-1.38-11.77-19.9-12.47-20.98-.6-.98-2.09-1.08-2.69 0-.9 1.57-11.77 20-12.37 20.88-.7 1.17.2 2.35 1.29 2.35h24.85c1.29 0 1.99-1.27 1.39-2.25zm-13.77-.49a1.1 1.1 0 0 1-1.09-1.08 1.1 1.1 0 0 1 2.19 0c0 .59-.5 1.08-1.1 1.08zm.6-3.14h-1.19l-1.4-8.23v-.1c0-1.08.9-1.96 1.99-1.96 1.1 0 2 .88 2 1.96v.1z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol